// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__358wy","list":"BalanceDue_list__3_aXZ","listRow":"BalanceDue_listRow__1W-nU","total":"BalanceDue_total__1CisQ"};